import { api } from '../index';
import { objectToFormData } from '@/api/util';

const prefix = '/api/basic_info/system_setting/';

export function apiSelectSystemSetting(param) {
	return api.post(prefix + 'selectSystemSetting', param);
}

export function apiUpdateSystemSetting(param) {
	return api.post(prefix + 'updateSystemSetting', param);
}

export function apiSelectJcEmailSettings() {
	return api.get(prefix + 'selectJcEmailSettings');
}

export function apiUpdateJcEmailSettings(settings) {
	return api.post(prefix + 'updateJcEmailSettings', settings);
}

export function apiGetGlobalSettings(param) {
	return api.get(prefix + 'getGlobalSettings', param);
}

export function apiUpdateAppVersion(param) {
	return api.post(prefix + 'updateAppVersion', param);
}

export function apiEmailTest(param) {
	return api.post(prefix + 'emailTest', param);
}

export function apiSelectSystemSettingsBykeyArr(key_arr) {
	return api.post(prefix + 'selectSystemSettingsBykeyArr', objectToFormData({ key_arr }));
}
